import Modal from "../../../common/components/Modal";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import { requestConfirmation } from "~/AddToCart/ModalSevice";
import { Alert } from "~/common/m3/Alert/Alert";

export const useQuoteIsBundleInfoModal = () => {
  return {
    requestConfirmation: () =>
      requestConfirmation(({ onCancel, onConfirm }) => (
        <QuoteIsBundleInfoModal onClose={onCancel} onConfirm={onConfirm} />
      )),
  };
};

const QuoteIsBundleInfoModal = ({ onClose, onConfirm }: { onClose: () => void; onConfirm: () => void }) => {
  const { t } = useTranslation();

  const footer = (
    <Button onClick={onConfirm} data-test-id={"confirmation-modal-ok"}>
      {t("generic.ok")}
    </Button>
  );

  return (
    <Modal onClose={onClose} footerChildren={footer}>
      <Alert severity={"info"} className={"mb-30"}>
        {t("page.quoteDetails.message.bundle")}
      </Alert>
    </Modal>
  );
};
